import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import some from 'lodash/some';
import DashboardFreelancerMain from '../../components/DashboardFreelancerMain';
import { PortfolioPopup, VacationPopup } from '../../components/';
import { openDialog, closeDialog } from '../../store/actions/Dialog';
import {
  saveDayAvailability,
  changeDayAvailability,
  fetchWeekAvailability,
  setAdvancedDay,
  setAdvancedCheckbox,
  saveAdvancedSchedule,
  fetchAdvancedAvailability,
  changeAdvancedSchedule,
  fetchInstantBookInfo,
  updateInstantBookInfo,
} from '../../store/actions/DashboardFreelancer';

import { updateAccount } from '../../store/actions/Authentication';
import { routesAction, scrollUp } from '../../shared/helpers';
import { setProject } from '../../store/actions/ProjectView';
import { fetchUserProjects } from '../../store/actions/Dashboard';
import { AddPortfolioPopup } from '../../components/Popup/AddPortfolioPopup';
import { addFlashMessage, clearMessage } from '../../store/actions/Flash';
import FreelancerPortfolioForm from '../../components/FreelancerPortfolioForm/FreelancerPortfolioForm';
import { setCurrentOnboardingStep } from '../../store/actions/FreelancerOnboarding';

const filters = {
  byStatus: (p, status) => p.status === status,
};

class DashboardFreelancer extends Component {
  constructor(props) {
    super(props);
    this.handleSelectTime = this.handleSelectTime.bind(this);
    this.handleToggleInstantBooking = this.handleToggleInstantBooking.bind(
      this,
    );
    this.handleToggleAvailability = this.handleToggleAvailability.bind(this);
    this.handleAdvancedHours = this.handleAdvancedHours.bind(this);
    this.handleAdvancedDay = this.handleAdvancedDay.bind(this);
    this.handleAdvancedCheckbox = this.handleAdvancedCheckbox.bind(this);
    this.handleGoToProjectView = this.handleGoToProjectView.bind(this);
    this.openPortfolioPopup = this.openPortfolioPopup.bind(this);
    this.handleGoToFreelancerOnboarding = this.handleGoToFreelancerOnboarding.bind(this);
    this.handleUpdateExperience = this.handleUpdateExperience.bind(this);
    this.handleUpdateInstantBookInfo = this.handleUpdateInstantBookInfo.bind(
      this,
    );
  }

  handleAdvancedCheckbox(event, { checked }) {
    this.props.dispatchSetAdvancedCheckbox({ available: checked });
  }

  handleAdvancedDay(date) {
    const prevDate = this.props.advancedAvailability.find(adv =>
      moment(adv.day).isSame(date.date),
    );

    this.props.dispatchSetAdvancedDay(
      prevDate ? { date: prevDate.day, id: prevDate.id, hours: null } : date,
    );
  }

  componentDidMount() {
    const {
      dispatchOpenDialog,
      dispatchCloseDialog,
      hasPortfolioProjects,
      dispatchFetchWeekAvailability,
      dispatchFetchAdvancedAvailability,
      dispatchFetchUserProjects,
      dispatchFetchInstantBookInfo,
    } = this.props;

    this.updateCurrentStep();

    dispatchFetchWeekAvailability();
    dispatchFetchAdvancedAvailability();
    dispatchFetchUserProjects();
    dispatchFetchInstantBookInfo();

    this.showVacationPopup(dispatchOpenDialog);

    if (!hasPortfolioProjects) {
      this.showPortfolioPopup(dispatchCloseDialog, dispatchOpenDialog);
    }
  }

  showPortfolioPopup(dispatchCloseDialog, dispatchOpenDialog) {
    const portfolioPopup = {
      id: 'portfolio-popup',
      body: (
        <PortfolioPopup
          handleUploadPortfolio={() => {
            this.openPortfolioPopup();
          }}
          handleUploadPortfolioLater={dispatchCloseDialog}
        />
      ),
    };

    dispatchOpenDialog(portfolioPopup);
  }

  showVacationPopup(dispatchOpenDialog) {
    const {
      dispatchTurnOffVacationMode,
      user: { available_schedule: availableSchedule, id },
    } = this.props;

    if (availableSchedule) return;

    const vacationPopup = {
      id: 'vacation-popup',
      body: (
        <VacationPopup
          handleTurnOffVacationMode={() =>
            dispatchTurnOffVacationMode({
              id,
              available_schedule: true,
            })
          }
        />
      ),
    };

    dispatchOpenDialog(vacationPopup);
  }

  updateCurrentStep() {
    this.props.dispatchUpdateAccount({
      current_step: 'dashboard',
    });
  }

  handleAdvancedHours({ hours }) {
    const { pendingDay } = this.props;

    if (!pendingDay) return;

    if (pendingDay.id) {
      this.props.dispatchUpdateAdvancedSchedule({ ...pendingDay, hours });
    } else {
      this.props.dispatchSaveAdvancedSchedule({ ...pendingDay, hours });
    }
  }

  handleToggleAvailability() {
    const {
      user: { available_schedule: availableSchedule, id },
    } = this.props;
    this.props.dispatchUpdateAccount({
      id,
      available_schedule: !availableSchedule,
    });
  }

  handleUpdateExperience(experience) {
    const { user, dispatchUpdateAccount } = this.props;
    if (!some(user.experiences, experience)) {
      return dispatchUpdateAccount({
        id: user.id,
        experiences: [experience],
      });
    }

    return Promise.resolve();
  }

  handleToggleInstantBooking() {
    const {
      user: { instant_book: instantBook, id },
      dispatchUpdateAccount,
    } = this.props;
    dispatchUpdateAccount({ id, instant_book: !instantBook });
  }

  handleSelectTime(event, data) {
    const { value, weekday } = data;
    const { weekAvailability } = this.props;
    const day = weekAvailability.find(week => week.day === weekday);

    if (day) {
      this.props.dispatchUpdateDayAvailability({
        id: day.id,
        hours: value,
        day: weekday,
      });
    } else {
      this.props.dispatchSaveDayAvailability({ hours: value, day: weekday });
    }
  }

  handleGoToProjectView(project) {
    const {
      dispatchSetProject,
      history: { push },
    } = this.props;

    dispatchSetProject(project);
    push(routesAction.project(project.id));
    scrollUp();
  }

  handleUpdateInstantBookInfo(params) {
    this.props.dispatchUpdateInstantBookInfo(params);
  }

  openPortfolioPopup() {
    const { dispatchOpenDialog, dispatchAddPortfolioItem, user } = this.props;

    const addPortfolioPopup = {
      id: 'add-portfolio-popup',
      body: (
        <AddPortfolioPopup>
          <FreelancerPortfolioForm
            onSubmit={({ submissions }, resetForm) =>
              dispatchAddPortfolioItem({ ...user, submissions }, resetForm)
            }
            submissions={[]}
          />
        </AddPortfolioPopup>
      ),
    };

    dispatchOpenDialog(addPortfolioPopup, {
      closeOnDimmerClick: false,
      closeOnEscape: false,
    });
  }

  handleGoToFreelancerOnboarding(event, step) {
    event.preventDefault();
    const {
      history: { push },
      dispatchSetCurrentOnboardingStep,
    } = this.props;
    dispatchSetCurrentOnboardingStep(step);
    push(routesAction.freelancerOnboarding(step));
  }

  render() {
    const {
      user,
      weekAvailability,
      advancedAvailability,
      projects,
      instantBookInfo,
    } = this.props;

    const newProjects = projects.filter(p =>
      filters.byStatus(p, 'new_project'),
    );

    const activeProjects = projects.filter(p => filters.byStatus(p, 'active'));

    const pastProjects = projects.filter(p => filters.byStatus(p, 'past'));

    return (
      <DashboardFreelancerMain
        user={user}
        weekAvailability={weekAvailability}
        advancedAvailability={advancedAvailability}
        handleSelectTime={this.handleSelectTime}
        handleToggleAvailability={this.handleToggleAvailability}
        handleToggleInstantBooking={this.handleToggleInstantBooking}
        handleAdvancedHours={this.handleAdvancedHours}
        handleAdvancedDay={this.handleAdvancedDay}
        handleAdvancedCheckbox={this.handleAdvancedCheckbox}
        newProjects={newProjects}
        pastProjects={pastProjects}
        activeProjects={activeProjects}
        handleGoToProjectView={this.handleGoToProjectView}
        instantBookInfo={instantBookInfo}
        handleUpdateInstantBookInfo={this.handleUpdateInstantBookInfo}
        openPortfolioPopup={this.openPortfolioPopup}
        handleGoToFreelancerOnboarding={this.handleGoToFreelancerOnboarding}
        handleUpdateExperience={this.handleUpdateExperience}
      />
    );
  }
}

DashboardFreelancer.propTypes = {
  user: PropTypes.object,
  dispatchSaveDayAvailability: PropTypes.func,
  dispatchFetchWeekAvailability: PropTypes.func,
  dispatchUpdateDayAvailability: PropTypes.func,
  dispatchUpdateAccount: PropTypes.func,
  weekAvailability: PropTypes.array,
  advancedAvailability: PropTypes.array,
  dispatchOpenDialog: PropTypes.func,
  dispatchCloseDialog: PropTypes.func,
  dispatchTurnOffVacationMode: PropTypes.func,
  hasPortfolioProjects: PropTypes.bool,
  dispatchSetAdvancedDay: PropTypes.func,
  dispatchSetAdvancedCheckbox: PropTypes.func,
  dispatchSaveAdvancedSchedule: PropTypes.func,
  dispatchFetchAdvancedAvailability: PropTypes.func,
  dispatchUpdateAdvancedSchedule: PropTypes.func,
  dispatchUpdateInstantBookInfo: PropTypes.func,
  pendingDay: PropTypes.object,
  history: PropTypes.shape({
    push: PropTypes.func,
  }),
  dispatchSetProject: PropTypes.func,
  dispatchFetchUserProjects: PropTypes.func,
  dispatchFetchInstantBookInfo: PropTypes.func,
  dispatchAddPortfolioItem: PropTypes.func,
  dispatchSetCurrentOnboardingStep: PropTypes.func,
  projects: PropTypes.array,
  instantBookInfo: PropTypes.array,
};

const mapStateToProps = state => {
  const {
    weekAvailability,
    pendingDay,
    advancedAvailability,
    instantBookInfo,
  } = state.dashboardFreelancer;
  return {
    pendingDay,
    instantBookInfo,
    weekAvailability,
    advancedAvailability,
    user: state.authentication.user,
    hasPortfolioProjects:
      state.authentication.user.submissions &&
      state.authentication.user.submissions.length > 0,
    projects: state.dashboard.projects,
  };
};

const mapDispatchToProps = (dispatch, { history }) => ({
  dispatchOpenDialog: (content, options) =>
    dispatch(openDialog(content, options)),
  dispatchCloseDialog: () => dispatch(closeDialog()),
  dispatchSaveDayAvailability: weekDay => {
    dispatch(saveDayAvailability(weekDay));
  },
  dispatchUpdateDayAvailability: weekDay => {
    dispatch(changeDayAvailability(weekDay));
  },
  dispatchFetchWeekAvailability: () => {
    dispatch(fetchWeekAvailability());
  },
  dispatchUpdateAccount: userAccount => dispatch(updateAccount(userAccount)),
  dispatchSetAdvancedDay: day => {
    dispatch(setAdvancedDay(day));
  },
  dispatchSetAdvancedCheckbox: value => {
    dispatch(setAdvancedCheckbox(value));
  },
  dispatchSaveAdvancedSchedule: day => {
    dispatch(saveAdvancedSchedule(day));
  },
  dispatchUpdateAdvancedSchedule: day => {
    dispatch(changeAdvancedSchedule(day));
  },
  dispatchFetchAdvancedAvailability: () => {
    dispatch(fetchAdvancedAvailability());
  },
  dispatchTurnOffVacationMode: userAccount => {
    dispatch(updateAccount(userAccount));
    dispatch(closeDialog());
  },
  dispatchSetProject: project => dispatch(setProject(project)),
  dispatchFetchUserProjects: () => dispatch(fetchUserProjects()),
  dispatchFetchInstantBookInfo: () => dispatch(fetchInstantBookInfo()),
  dispatchUpdateInstantBookInfo: params =>
    dispatch(updateInstantBookInfo(params)),
  dispatchAddPortfolioItem: (values, resetForm) => {
    dispatch(updateAccount(values)).then(action => {
      if (action && action.type === 'UPDATE_ACCOUNT_SUCCESS') {
        resetForm();
        history.push(routesAction.default());
        dispatch(clearMessage());
        dispatch(
          addFlashMessage(['Your portfolio has been updated!'], 'success'),
        );
        dispatch(closeDialog());
      }
    });
  },
  dispatchSetCurrentOnboardingStep: onboardingStep => {
    dispatch(setCurrentOnboardingStep(onboardingStep));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DashboardFreelancer);



// WEBPACK FOOTER //
// ./src/containers/DashboardFreelancer/DashboardFreelancer.js